import React from 'react';
import { LoadingOverlay } from '../../../../../components';

export default class TotalUninstallations extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        loading: false
      });
    }, 300);
  }

  render() {
    const androidData = this.props.android;
    const appleData = this.props.apple;
    return (
      <div className="widget widget-auto-height">
        <div className="dark-blur" />
        <div className="widget-header">
          <h3 className="widget-title">
            <i className="fa fa-ban" aria-hidden="true" /> Total Uninstallations
            last 7 days
          </h3>
        </div>
        <div className="widget-inner">
          {this.state.loading ? (
            <LoadingOverlay />
          ) : (
            <div className="widget-new-customers">
              <div>
                <i className="fa fa-ban" aria-hidden="true" />
                <p className="customers-number">
                  {androidData.Uninstalls.googleUninstallsInLastWeek +
                    appleData.UninstallsLastWeek}{' '}
                  <span>uninstallations</span>
                </p>
              </div>
              <ul>
                <li>Android</li>
                <li>{androidData.Uninstalls.googleUninstallsInLastWeek}</li>
              </ul>
              <ul>
                <li>Apple</li>
                <li>{appleData.UninstallsLastWeek}</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  }
}
